"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLowercaseHumanReadable = exports.toHumanReadable = exports.capitalize = exports.CapitalizationOptions = void 0;
var CapitalizationOptions;
(function (CapitalizationOptions) {
    CapitalizationOptions["FIRST_WORD"] = "FIRST_WORD";
    CapitalizationOptions["ALL_WORDS"] = "ALL_WORDS";
    CapitalizationOptions["NONE"] = "NONE";
})(CapitalizationOptions || (exports.CapitalizationOptions = CapitalizationOptions = {}));
/**
 * Capitalizes a string based on the provided option.
 *
 * @param str - string to convert
 * @param option - capitalization to use
 *
 * @returns string with chosen capitalization applied
 *
 * @example
 * capitalize("hello world") // "Hello world"
 * capitalize("hello world", CapitalizationOptions.ALL_WORDS) // "Hello World"
 * capitalize("hello world", CapitalizationOptions.FIRST_WORD) // "Hello world"
 * capitalize("hello world", CapitalizationOptions.NONE) // "hello world"
 */
const capitalize = (str, option = CapitalizationOptions.FIRST_WORD) => {
    switch (option) {
        case CapitalizationOptions.FIRST_WORD: {
            const firstWord = str.split(" ")[0];
            // If the word is all uppercase, we assume it's an acronym and leave it as is
            if (firstWord === firstWord.toUpperCase()) {
                return firstWord + str.slice(firstWord.length).toLowerCase();
            }
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
        case CapitalizationOptions.ALL_WORDS: {
            return str
                .split(" ")
                .map((word) => {
                // If the word is all uppercase, we assume it's an acronym and leave it as is
                if (word === word.toUpperCase()) {
                    return word;
                }
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
                .join(" ");
        }
        case CapitalizationOptions.NONE:
            return str.toLowerCase();
    }
};
exports.capitalize = capitalize;
/**
 * Converts a PascelCase/camelCase string to a human readable string.
 *
 * @param str - string to convert
 * @param capitalization - capitalization to use
 *
 * @returns human readable string with spaces inserted between words, and chosen capitalization applied
 *
 * @example
 * toHumanReadable("helloWorld") // "Hello world"
 * toHumanReadable("helloWorld", CapitalizationOptions.ALL_WORDS) // "Hello World"
 * toHumanReadable("helloWorld", CapitalizationOptions.FIRST_WORD) // "Hello world"
 * toHumanReadable("helloWorld", CapitalizationOptions.NONE) // "hello world"
 */
const toHumanReadable = (str, capitalization = CapitalizationOptions.FIRST_WORD) => {
    const spacedString = str
        .replace(/([A-Z][a-z])/g, " $1")
        .replace(/[,_-]/g, " ")
        .trim();
    return (0, exports.capitalize)(spacedString, capitalization);
};
exports.toHumanReadable = toHumanReadable;
const toLowercaseHumanReadable = (str) => (0, exports.toHumanReadable)(str, CapitalizationOptions.NONE);
exports.toLowercaseHumanReadable = toLowercaseHumanReadable;
//# sourceMappingURL=toHumanReadable.js.map